<template>
    <div class="ma-4">
      <StaffNav class="hideOnPrint" />
      <v-row class="hideOnPrint">
        <v-col cols="12" lg="3" xl="2">
          <StaffSide />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-data-table
            :headers="headers"
            :items="items"
            sort-by="Date"
            sort-desc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Incentives"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Incentives</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>                         
  
                <v-spacer></v-spacer>
                <!-- <report-list-actions
                  :reportOptions="reportOptions"
                  :downloadFilename="reportListFilename"
                ></report-list-actions> -->
  
                <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" @click="showAdd">
                  <v-icon left>add</v-icon>
                  Add Incentive
                </v-btn>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>
  
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="onViewItem(item)" color="primary">
                mdi-eye
              </v-icon>
  
              <v-icon v-if="!isAuditorRole" small @click="confirmDelete(item)" color="error"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="fetchItems"
                >Reset</v-btn
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <Foot class="hideOnPrint" />
    </div>
  </template>
  
  <script>
  /*eslint-disable */
  import { mapState, mapActions } from "vuex";
  import StaffNav from "@/components/StaffNav";
  import StaffSide from "@/components/StaffSide";
  import Foot from "@/components/Footer";
  import renameFileHelper from "@/mixins/renameFileHelper";
  import ReportListActions from '@/components/Report/ReportListActions.vue'
  
  export default {
    mixins: [renameFileHelper],
    components: {
      StaffNav,
      StaffSide,
      Foot,
      ReportListActions
    },
    data: function () {
      return {
        headers: [
          {
            text: "Date",
            align: "start",
            sortable: true,
            value: "Date",
          },
          { text: "Type of Incentive", value: "TypeOfIncentive" },
          { text: "Amount", value: "Amount" },
          { text: "", value: "actions", sortable: false },
        ],
        search: "",
        // incentives: [],
        employeeID: this.$route.params.employeeID,
        isPrintingTable: false,
      };
    },
  
    computed: {
      ...mapState("incentives", ["items", "isLoading"]),
  
      staffName() {
        return this.$store.state.users.user.Name;
      },
  
      selectedEmployee() {
        return this.$store.state.users.allUsers.find(
            (user) => user._id == this.employeeID
        )
      },
  
      employeeName() {
        return this.selectedEmployee.Name ?? this.staffName
      }, 
    
      reportOptions() {
        return { 
          query: {
            name: this.employeeName,
          },
          endpoints: `garnishments/printList/${this.employeeID}`,
          dynamic: true
        }
      },
      reportListFilename() {
        return `${this.employeeName} - Staff Incentive`
      },
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }
    },
    created() {
      this.fetchItems();
    },
    methods: {
      ...mapActions("incentives", ["getItems", "deleteItem", "downloadItem"]),
  
      onViewItem(item) {
        this.$router.push({
          path: `/incentives/${this.employeeID}/edit`,
          query: { id: item._id, new: false },
        });
      },
  
      showAdd() {
        this.$router.push({
          path: `/incentives/${this.employeeID}/add`,
        });
      },
  
      confirmDelete(item) {
        const id = item._id;
        if (confirm("Are you sure you want to delete this record?")) {
          this.deleteItem({ id, userId: this.employeeID });
        }
      },
  
      fetchItems() {
        this.getItems(this.employeeID);
      },
    },
  };
  </script>
  
  <style>
  
  #printItem {
    display: none;
  }
  
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  
  @media print {
    #printItem {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }
    .hideOnPrint {
      display: none;
      border: none;
    }
  
    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
      display: none;
      border: none;
    }
  
    @page {
      margin: 0;
    }
    body {
      margin: 1.6cm;
    }
  }
  </style>
  